/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconSchema = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M13.5 6.748a3.75 3.75 0 1 1 0 7.5 3.75 3.75 0 0 1 0-7.5zM21 .748a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5zM21 13.498a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5zM13.5 18.748a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5zM3 18.748a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5zM3.75 2.998a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5zM16.151 7.848l3.26-3.26M16.794 12.292l2.285 2.285M13.5 14.248v4.5M10.851 13.147L4.59 19.408M10.001 9.149L5.61 6.514" />
      </g>
    </svg>
  ),
);
